import { createModel, RematchDispatch } from '@rematch/core';
import * as poiTemplateService from '../../services/poiTemplate.service';
import { WebRotateType } from '../../types/cmsWebRotate.type';
import { PaginationType } from '../../types/CommonTypes';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'poiTemplateEntity';

export const poiTemplateEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof poiTemplateEntity>) => ({
    async load(params): Promise<{ content?: WebRotateType[] } & PaginationType> {
      try {
        const res = await poiTemplateService.filter(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saves(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async createPoiTemplate(payload) {
      try {
        const res = await poiTemplateService.create(payload);
        return res;
      } catch (e) {
        console.error(e);
      }
    },
    async delete(id) {
      try {
        const res = await poiTemplateService.deleteById(id);
        if (res && res.data) {
          this.remove({ id });
        }
        return res;
      } catch (e) {
        throw new Error(e);
      }
    },
    async updatePoiTemplate(payload) {
      try {
        const res = await poiTemplateService.update(payload.id, payload);
        return res;
      } catch (e) {
        console.error(e);
      }
    },
    async findById(payload, state) {
      try {
        const item = state[storeName].ids[payload];
        if (item && !item.isSimplified) {
          return item;
        }
        const res = await poiTemplateService.getById(payload);
        this.update(res.data);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default poiTemplateEntity;
